export default {
  no_mobile_app: 'Nenhuma App Móvel configurada',
  mobile_app_not_live: 'App Móvel não está ativa',
};
